import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function ViewSection() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("viewSection");
    if (!stored) {
      navigate(-1);
      return;
    }
    setData(JSON.parse(stored));
  }, [navigate]);

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title mb-0">View Section</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <Link to="/module-list">Modules</Link>
                <span className="mx-2">/</span>
                <Link to="/solutions-list">Solutions</Link>
                <span className="mx-2">/</span>
                <Link to="/sections-list">Sections</Link>
                <span className="mx-2">/</span>
                <span>View</span>
              </nav>
            </div>
          </div>

          <Link
            to="/sections-list"
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", borderRadius: "8px" }}
          >
            <FaArrowLeft />
          </Link>
        </div>
      </div>

      <div className="main_page">
        <div className="st-wrapper-card p-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <strong>Section Key:</strong>
              <p>{data?.section_key || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Type:</strong>
              <p>{data?.type || "-"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Title:</strong>
              <p>{data?.title || "-"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Subtitle:</strong>
              <p>{data?.subtitle || "-"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Description:</strong>
              <p>{data?.description || "-"}</p>
            </div>
            <div className="col-md-12 mb-3">
              <strong>Image:</strong>
              <p>{data?.image || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Sort Order:</strong>
              <p>{data?.sort_order}</p>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Status:</strong>
              <p>{data?.status === 1 ? "Active" : "Inactive"}</p>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/sections-list")}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewSection;